const scrollIndicator = {
  el: '',
  init() {
    this.el = $q('#scroll-indicator')

    if (!this.el.first) return

    this.build()
  },
  build() {
    window.addEventListener('scroll', () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight
      const scrolled = (winScroll / height) * 100
      document.getElementById('scroll-indicator').style.width = scrolled + '%'
    })
  }
}
export default scrollIndicator
